export class Foliage {
  static typeName = 'FOLIAGE'
}

export class Trunk {
  static typeName = 'TRUNK'
}
